import Button from 'components/forms/Button'

import styles from './styles/FiltersSubmit.css'

export const FiltersSubmit = ({
  toggleFilter
}) => (
  <>
    <div className={styles.mobileSpacer} />
    <div className={styles.mobileButtons}>
      <Button className={styles.button} onClick={() => toggleFilter('showMobile')}>OK</Button>
    </div>
  </>
)

export default (FiltersSubmit)
